import React from 'react';
import {P3} from "../shared/fonts/fonts";
import {Images} from "../../utils/images";

const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const YEAR = 365 * DAY;

const diffString = (diff: number) => {
    if (diff < MINUTE) {
        return 'только что';
    }
    if (diff < HOUR) {
        return Math.round(diff / MINUTE) + ' мин. назад';
    }
    if (diff < DAY) {
        return Math.round(diff / HOUR) + ' ч. назад';
    }
    if (diff < YEAR) {
        return Math.round(diff / DAY) + ' д. назад';
    }
    return Math.round(diff / YEAR) + ' г. назад';
}

const MessageDate = (props: {date: Date}) => {
    const diff = Date.now() - props.date.getTime();
    return (
        <P3>
            {props.date.toLocaleString()} <img src={Images.icons.timer}
                                               style={{verticalAlign: 'text-top'}}/> {diffString(diff)}
        </P3>
    );
};

export default MessageDate;